import { Box, Breadcrumbs, Divider, Link, Paper, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import AppIconButton from "../../Common/Button/IconButton";
import AppTabs from "../../Common/Tabs/AppTabs";
import { LabelText, ValueText } from "../../Common/Typography/AppTypography";
import { getFormatedJSON } from "../../../utils/general";
import { useDesignTokens } from "../../../theme/useDesignTokens";
import NotificationTaskDetails from "./NotificationTaskDetails";

const NotificationTaskDetailsPage = ({
  title = "Task Details",
  content = "notificationDetails",
  data,
  tab = 0,
  onTabChange,
  onBack,
}) => {
  const { colors, font } = useDesignTokens();
  const primaryColor = colors?.primary?.main || "#ED6C02";
  const isUserDetails = content === "userNotificationDetails";

  return (
    <Box sx={{ width: "100%", maxWidth: "100%", minWidth: 0, boxSizing: "border-box", pb: 3 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.75,
          mb: { xs: 1.5, md: 2 },
          minWidth: 0,
        }}
      >
        <AppIconButton
          variant="ghost"
          size="small"
          icon={<ArrowBackIcon fontSize="small" />}
          tooltip="Back"
          onClick={onBack}
          aria-label="Back"
          sx={{ flexShrink: 0 }}
        />
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
          sx={{ minWidth: 0, "& .MuiBreadcrumbs-ol": { flexWrap: "wrap" } }}
        >
          <Link
            component="button"
            type="button"
            underline="hover"
            onClick={onBack}
            sx={{
              color: primaryColor,
              fontWeight: font?.weight?.fontW600 || 600,
              fontSize: "0.875rem",
              border: "none",
              background: "none",
              cursor: "pointer",
              p: 0,
            }}
          >
            Search Notification
          </Link>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontWeight: font?.weight?.fontW500 || 500 }}
          >
            {title}
          </Typography>
        </Breadcrumbs>
      </Box>

      <Paper
        elevation={0}
        sx={{
          width: "100%",
          minWidth: 0,
          border: `1px solid ${colors?.ghost?.light || "#E0E0E0"}`,
          borderRadius: 2,
          bgcolor: "#fff",
          boxShadow: "0 1px 4px rgba(0, 0, 0, 0.06)",
          overflow: "hidden",
          boxSizing: "border-box",
        }}
      >
        <Box sx={{ px: { xs: 1.5, sm: 2 }, pt: 0.5 }}>
          <AppTabs
            value={tab}
            onChange={(e, newValue) => onTabChange?.(newValue)}
            tabs={[{ label: "Details" }, { label: "JSON" }]}
            tabMinWidth="auto"
          />
        </Box>
        <Divider />
        <Box sx={{ p: { xs: 1.5, sm: 2.5 } }}>
          {tab === 0 ? (
            isUserDetails ? (
              data ? (
                <Box>
                  {data.fullUniqueId && (
                    <Box sx={{ mb: 1.5 }}>
                      <LabelText sx={{ fontWeight: 400, color: "text.secondary" }}>
                        Unique ID
                      </LabelText>
                      <ValueText sx={{ wordBreak: "break-all" }}>
                        {data.fullUniqueId}
                      </ValueText>
                    </Box>
                  )}
                  <LabelText sx={{ fontWeight: 400, color: "text.secondary", mb: 0.5 }}>
                    Message
                  </LabelText>
                  <Box>{getFormatedJSON(data.msg)}</Box>
                </Box>
              ) : null
            ) : (
              <NotificationTaskDetails task={data?.mappedTask} rawTask={data?.payload} />
            )
          ) : (
            <Box
              sx={{
                p: { xs: 1.5, sm: 2 },
                borderRadius: 1,
                bgcolor: "grey.50",
                border: "1px solid",
                borderColor: "divider",
                overflowX: "auto",
              }}
            >
              {getFormatedJSON(data?.payload)}
            </Box>
          )}
        </Box>
      </Paper>
    </Box>
  );
};

export default NotificationTaskDetailsPage;
